import { UserSessionI } from "../auth/authTypes";
import { UserPayloadI, getProfileTypes, profileTypes } from "./profileTypes";

export const getUserInformation = (): getProfileTypes => ({
  type: profileTypes.GET_USER_INFORMATION,
});

export const getUserInformationSuccess = (payload: UserSessionI): getProfileTypes => ({
  type: profileTypes.GET_USER_INFORMATION_SUCCESS,
  payload,
});

export const getUserInformationFailure = (payload: string): getProfileTypes => ({
  type: profileTypes.GET_USER_INFORMATION_FAILURE,
  payload,
});

export const updateInformation = (
  payload: UserPayloadI,
  scb: () => void,
  fcb: (error: string) => void,
): getProfileTypes => ({
  type            : profileTypes.UPDATE_INFORMATION,
  payload,
  successCallback : scb,
  failureCallback : fcb,
});

export const updateInformationSuccess = (payload: UserSessionI): getProfileTypes => ({
  type: profileTypes.UPDATE_INFORMATION_SUCCESS,
  payload,
});

export const updateInformationFailure = (payload: string): getProfileTypes => ({
  type: profileTypes.UPDATE_INFORMATION_FAILURE,
  payload,
});

export const updateAvatar = (payload: FormData, scb?: () => void, fcb?: (error: string) => void): getProfileTypes => ({
  type            : profileTypes.UPDATE_AVATAR,
  payload,
  successCallback : scb,
  failureCallback : fcb,
});

export const updateAvatarSuccess = (payload: UserSessionI): getProfileTypes => ({
  type: profileTypes.UPDATE_AVATAR_SUCCESS,
  payload,
});

export const updateAvatarFailure = (payload: string): getProfileTypes => ({
  type: profileTypes.UPDATE_AVATAR_FAILURE,
  payload,
});
